import { FC } from 'react';

import { ConsoleAPIGraph, CreativeHubTypes } from '@adflow/graphqlgen';
import { AdElement, AdflowAPI } from '@adflow/types';

import type { SoccerFixture } from '../../soccerPreview';
import {
  useResolvedAdElements,
  type PreviewFontDescriptor,
} from '../../hooks/useResolvedAdElements';
import { PreviewPresentation } from './PreviewPresentation';
import type { PreviewPresentationProps } from './PreviewPresentation';

type ResolutionProps = {
  elements: AdElement[];
  brand: ConsoleAPIGraph.Brand | null;
  brandKit?: CreativeHubTypes.Brand | null;
  fonts: readonly PreviewFontDescriptor[];
  displayOptions?: AdflowAPI.AdTemplateDisplayOptions | null;
  customizations?: Record<string, string> | null;
  dataSources?: Array<{ id: string; type: string }>;
  activeSoccerFixture?: SoccerFixture | null;
  resolveSoccerCustomAssetUrls?: boolean;
  animation?: AdflowAPI.Animation | null;
  animationPlaybackToken?: number;
  playheadSeconds?: number | null;
  presentation: Omit<
    PreviewPresentationProps,
    'layoutElements' | 'mappedElements' | 'animationOverrides'
  >;
};

export const PreviewWithResolution: FC<ResolutionProps> = ({
  elements,
  brand,
  brandKit,
  fonts,
  displayOptions,
  customizations,
  dataSources,
  activeSoccerFixture,
  resolveSoccerCustomAssetUrls,
  animation,
  animationPlaybackToken,
  playheadSeconds,
  presentation,
}) => {
  const { resolvedElements, animationOverrides } = useResolvedAdElements({
    elements,
    brand,
    brandKit,
    fonts,
    displayOptions,
    customizations,
    dataSources,
    activeSoccerFixture,
    resolveSoccerCustomAssetUrls,
    animation,
    animationPlaybackToken,
    playheadSeconds,
  });

  return (
    <PreviewPresentation
      layoutElements={elements}
      mappedElements={resolvedElements}
      animationOverrides={animationOverrides}
      {...presentation}
    />
  );
};

PreviewWithResolution.displayName = 'PreviewWithResolution';
